import { WalletHistoryEntry } from 'network/services/wallet';
import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import ListElement from './listElement';
interface props {
  data: WalletHistoryEntry[];
  setvalue: Dispatch<SetStateAction<number>>;
  value: number;
  totalpages: number;
}
export const WalletHistoryMessage: React.FC<props> = ({ data, setvalue, value, totalpages }) => {
  const queryClient = useQueryClient();

  const goto = useNavigate();

  return (
    <div className="list-con">
      {data.map(mes => (
        <div key={mes.id}>
          <ListElement
            amountState={mes.type}
            time={mes.createdAt}
            name={mes.title}
            specialization={mes.description}
            amount={mes.amount}
            status={mes.status}
            reference={mes.reference}
            balanceBefore={mes.balanceBefore}
            balanceAfter={mes.balanceAfter}
          />
        </div>
      ))}
      {totalpages > 1 ? (
        <div className="w-full flex justify-between">
          <button
            onClick={() => {
              setvalue(value - 1);
              goto(`/account/wallet?page=${Number(value) - 1}`);
              queryClient.invalidateQueries('wallet_histories');
            }}
            data-hidden={value === 0}
            className={
              'data-[hidden=true]:opacity-0 data-[hidden=true]:pointer-events-none underline text-blue-800 cursor-pointer'
            }>
            Previous
          </button>
          <button
            onClick={() => {
              setvalue(value + 1);
            }}
            data-hidden={Number(value) === totalpages - 1}
            className={`data-[hidden=true]:opacity-0 data-[hidden=true]:pointer-events-none underline text-blue-800 cursor-pointer`}>
            Next
          </button>
        </div>
      ) : null}
    </div>
  );
};
